<div class="container">
  <ul class="progressbar">
    <li class="active" id="basic">
      <i class="pi pi-id-card header-icon active-header-icon"></i>
      {{'basic-profile.fields.base_data' | translate}}
    </li>
    <li class="inactive" id="upload">
      <i class="pi pi-upload header-icon"></i>
      {{'basic-profile.fields.upload' | translate}}
    </li>
    <li class="inactive" id="authorities">
      <i class="pi pi-list header-icon"></i>
      {{'basic-profile.fields.permissions' | translate}}
    </li>
    <li class="inactive" id="approval">
      <i class="pi pi-sign-out header-icon"></i>
      {{'basic-profile.fields.admission' | translate}}
    </li>
    <li *ngIf="enabled" class="inactive" id="submit">
      <i class="pi pi-folder header-icon"></i>
      {{'basic-profile.jurisdiction.proceed' | translate}}
    </li>
  </ul>
</div>
